import { render, staticRenderFns } from "./HcArchivedRecords.vue?vue&type=template&id=413075f8&"
import script from "./HcArchivedRecords.vue?vue&type=script&lang=js&"
export * from "./HcArchivedRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports